// src="https://d1mluz1pfkw29o.cloudfront.net/pop-up/2025_spring_sales_desktop.jpeg"

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { parseISO, isAfter} from 'date-fns';
import axios from "axios";
import yaml from 'js-yaml';
import {PromoConfig} from "../settings";

// const EXPIRATION_DATE = new Date('2025-05-06'); // Spring sales end date

export default function ImagePrompt({ isMobile }) {
    const [visible, setVisible] = useState(true);
    const [expirationDate, setExpirationDate] = useState("2025-05-05T00:00:00Z");
    const [imageUrl, setImageUrl] = useState("https://d1mluz1pfkw29o.cloudfront.net/pop-up/2025_spring_sales_mobile.jpeg");
    const [imageUrlDesktop, setImageUrlDesktop] = useState("https://d1mluz1pfkw29o.cloudfront.net/pop-up/2025_spring_sales_desktop.jpeg");
    const [link, setLink] = useState("https://vieunite.com/home/digital-canvas?promocode=SAVE20");

    useEffect(() => {
        // Fetch expiration date from server
        const fetchExpirationDate = async () => {
            try {
                const response = await axios.get(PromoConfig, {
                    headers: {
                        'Cache-Control': 'no-cache',
                        'Pragma': 'no-cache'
                    }
                });
                const yml = yaml.load(response.data);
                console.log("reading date https://vieunite.com/promo_expiration.txt");
                console.log(response);
                console.log("is after: " + isAfter(new Date(), parseISO(yml.expire)) + " " + response.data);
                if (response?.data) {
                    setExpirationDate(yml.expire);
                    setImageUrl(yml.image_url);
                    setImageUrlDesktop(yml.image_url_desktop);
                    setLink(yml.link);
                }
            } catch (error) {
                console.error('Failed to fetch expiration date:', error);
                // Fallback to a default date or handle error appropriately
            }
        };
        fetchExpirationDate();
    }, []);


    useEffect(() => {

        if (visible && !isAfter(new Date(), parseISO(expirationDate))) {
            document.body.style.overflowY = 'hidden';
            document.body.style.overflowX = 'hidden';
        } else {
            document.body.style.overflowY = '';
        }

        return () => {
            document.body.style.overflowY = '';
        };
    }, [visible, expirationDate]);

    if (!visible || isAfter(new Date(), parseISO(expirationDate))) return null;

    return createPortal(
        <div style={overlayStyle}>
            <div style={modalStyle}>
                <button style={closeButtonStyle} onClick={() => setVisible(false)}>
                    &times;
                </button>
                <img
                    // src={isMobile ? "https://d1mluz1pfkw29o.cloudfront.net/pop-up/2025_spring_sales_mobile.jpeg" : "https://d1mluz1pfkw29o.cloudfront.net/pop-up/2025_spring_sales_desktop.jpeg"}
                    src = {isMobile ? imageUrl : imageUrlDesktop}
                    alt="Prompt"
                    style={{ width: '100%', borderRadius: '12px', cursor: 'pointer' }}
                    onClick={() => {
                        // window.location.href = `${window.location.origin}/home/digital-canvas?promocode=SAVE200`;
                        window.location.href = link;
                        setVisible(false);
                    }}
                />
            </div>
        </div>,
        document.body
    );
}

const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
};

const modalStyle = {
    backgroundColor: 'white',
    // padding: '20px',
    borderRadius: '12px',
    maxWidth: '90%',
    maxHeight: '90%',
    position: 'relative',
    boxShadow: '0 0 20px rgba(0,0,0,0.3)',
};

const closeButtonStyle = {
    position: 'absolute',
    top: '12px',
    right: '12px',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    backgroundColor: 'white',
    border: '1px solid #ccc',
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#333',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
};
